import React, { Component } from 'react';
import Wix from '../../services/wix-sdk-polyfill';
import styles from './profile-actions-upper-part.scss';
import { hidePopup, COMMUNITIES_POPUP_SHOW, COMMUNITIES_POPUP_HIDE } from '../../services/widget-popup';

export class ProfileActionsUpperPart extends Component {
  state = {
    style: {},
  };

  componentDidMount = () => {
    Wix.PubSub.subscribe(COMMUNITIES_POPUP_SHOW, this.showPopup);
    Wix.PubSub.subscribe(COMMUNITIES_POPUP_HIDE, this.hidePopup);
  };

  componentWillUnmount = () => {
    Wix.PubSub.unsubscribe(COMMUNITIES_POPUP_SHOW, this.showPopup);
    Wix.PubSub.unsubscribe(COMMUNITIES_POPUP_HIDE, this.hidePopup);
  };

  showPopup = () => {
    Wix.setHeight(10000);
  };

  hidePopup = () => {
    Wix.setHeight(0);
  };

  handleHidePopup = () => {
    hidePopup();
  };

  render = () => {
    return <div onClick={this.handleHidePopup} className={styles.overlay}/>;
  };
}

export default ProfileActionsUpperPart;



// WEBPACK FOOTER //
// ./app/containers/profile-actions-upper-part/profile-actions-upper-part.js